'use client'
import Button from '@/components/Popup_Assistant/Button';
import { useStoreAction } from '@/hooks/context/StoreActionContext';
import { useChatContext } from '@copilotkit/react-ui';
import React, { useCallback, useImperativeHandle } from 'react'


interface PureButtonProps { }

const PureButton = ({ }: PureButtonProps) => {
  const { open, setOpen } = useChatContext();
  const { aiActionRef } = useStoreAction();
  const toggle = useCallback(() => setOpen(!open), [setOpen]);
  useImperativeHandle(aiActionRef, () => ({
    open: () => setOpen(true),
  }), [setOpen]);

  return (
    <Button
      open={open}
      toggle={toggle}
    />
  )
}

export default PureButton